import { useCallback } from 'react';

import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import { publish } from 'lib/EventBuser';
import { REFRESH_TABLE } from 'lib/events';

import {
    MARKETING_CAMPAIGN_STATUS,
    normalizeMarketingCampaignStatusId,
} from '../utils/marketingCampaignStatus';

const DETAIL_WIDTH = '1150px';
const DETAIL_CLASS_NAME = 'fm-marketing-campaign-entity-detail fm-custom-detail';

/**
 * Marketing campaign detail configuration for {@link EntityDetail}.
 * Header options (e.g. delete when allowed) and layout constants.
 */
const useMarketingCampaignsDetail = () => {
    const getOptions = useCallback((data) => {
        if (!data?.id) {
            return [];
        }

        const statusId = normalizeMarketingCampaignStatusId(data.status);
        const canDelete =
            statusId === MARKETING_CAMPAIGN_STATUS.DRAFT ||
            statusId === MARKETING_CAMPAIGN_STATUS.SCHEDULED;

        if (canDelete) {
            return ['delete'];
        }
        return [];
    }, []);

    const onDeleteEntity = useCallback(() => {
        publish(`${REFRESH_TABLE}_${CAMPAIGNS_MARKETING.entity}`);
    }, []);

    const getWidgets = useCallback(({ widgets = [] } = {}) => widgets, []);

    return {
        className: DETAIL_CLASS_NAME,
        entity: CAMPAIGNS_MARKETING,
        getOptions,
        getWidgets,
        onDeleteEntity,
        width: DETAIL_WIDTH,
    };
};

export default useMarketingCampaignsDetail;
